module.exports = __webpack_public_path__ + "img/preloader.cf555651.svg";